import { ContactHero } from '../components/sections/ContactHero';
import { ContactForm } from '../components/sections/ContactForm';
import { ContactQuickCTA } from '../components/sections/ContactQuickCTA';

const Contact = () => (
  <div>
    <ContactHero />
    <ContactForm />
    <ContactQuickCTA />
  </div>
);

export default Contact;
